import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/admin/materials/$id/edit")({
  params: {
    parse: (params) => z.object({ id: z.coerce.number() }).parse(params),
  },
});
